<template>
  <div :class="['youtube-player', { onboarding: isOnboarding }]">
    <iframe
      :src="`https://www.youtube-nocookie.com/embed/${videoId}?controls=1&amp;start=0&autoplay=0&rel=0&showinfo=0&fs=1&iv_load_policy=3`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "YoutubePlayer",
  props: {
    videoId: { type: String, required: true },
    isOnboarding: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.youtube-player {
  display: block;
  width: 100%;
  max-width: 100%;
}

.youtube-player iframe {
  display: block;
  width: 50%;
  max-width: 100%;
  aspect-ratio: 16/9;
  border: 0;
}

.youtube-player.onboarding iframe {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16/9;
}
</style>
